import React                      from 'react'
import { Table }                  from 'antd'
import { Observer }               from 'mobx-react'

import { TEXT
       , tr
       , tr_enum_role }           from '../00_assets'
import { kde_api_user_t
       , ROLE }                   from '../02_api'
import { MApp }                   from '../09_model_app'

import { avoid_closing_modal
       , ModalPrompt }            from './06_ui_modal_prompt'
import { EditButtons }            from './07_ui_edit_buttons'
import { create_user_editor_model
       , UserEditor }             from './10_ui_user_editor'
import { TableState }             from './11_ui_table_state'

export const UsersTable: React.FC<
   { users: kde_api_user_t[]
   , onDelete: ( user: kde_api_user_t ) => any
   , onEdit: ( user: kde_api_user_t, new_values: Partial< kde_api_user_t > ) => any
   , loading: boolean
   , buttonsDisabled?: boolean
   , canEdit: boolean
   } > = ( props ) =>
{
  const table_state = TableState( ) ;

  return <Observer render={ ( ) =>
  {
    const row_key = ( row: kde_api_user_t ) => row.id + ''
        , on_edit_user = (user: kde_api_user_t) =>
          { 
            const editor_model = create_user_editor_model( user ) ;

            ModalPrompt( tr( TEXT.USERS_EDIT_TITLE )
                      , <UserEditor form={ editor_model } />
                      , ( ) => props.onEdit( user, editor_model.fields( ) as any )
                      ) ;
          }
        , row_className = ( ) => "on-hover"
        , columns = [ { title: tr( TEXT.UI_USERNAME )
                      , dataIndex: 'username'
                      , ...table_state.sort_col( 'name'
                                               , (row: kde_api_user_t) => row.username )
                      , width: '33%'
                      }
                    , { title: tr( TEXT.UI_EMAIL )
                      , dataIndex: 'email'
                      , ...table_state.sort_col( 'email'
                                               , (row: kde_api_user_t) => row.email )
                      } 
                    , { title: tr( TEXT.UI_ROLE )
                      , ...table_state.sort_col( 'role'
                                               , (row: kde_api_user_t) => tr_enum_role( row.role.name ) )
                      , render: ( row: kde_api_user_t ) => <span>{ tr_enum_role( row.role.name ) }</span>
                      } 
                    , { title: ''
                      , key: 'actions'
                      , render: ( row: kde_api_user_t ) =>
                          <span>
                            {
                              props.canEdit?
                                <EditButtons
                                  row={ row }
                                  onEdit={ on_edit_user }
                                  onDelete={ props.onDelete }
                                  disabled={ props.buttonsDisabled }
                                />
                              : null
                            }
                          </span>
                      , width: '95px'
                      }
                    ] ;


    return <Table
            className="m-3 shadow"
            loading={ props.loading }
            columns={ columns }
            dataSource={ props.users }
            pagination={ false }
            rowKey={ row_key }
            rowClassName={ row_className }
            onChange={ table_state.on_table_change }
          /> ;
  } }/>
}

export function create_user_modal ( callback: ( user: kde_api_user_t ) =>  any, def_workgroup?: number | null )
{
  const cur_user     = MApp( ).user
      , editor_model = create_user_editor_model( { workgroup: { id:   def_workgroup? def_workgroup
                                                           : cur_user     ? cur_user.workgroup!.id
                                                           :                0 }
                                        , role: { name: ROLE.USER } 
                                        } as any )
      , add_user = ( ) =>
        {
          if ( editor_model.has_errors( ) )
               avoid_closing_modal( ) ;
          else
               callback( editor_model.fields( ) as any ) ;
        } ;

  ModalPrompt( tr( TEXT.USERS_NEW_TITLE )
              , <UserEditor form={ editor_model } />
              , add_user
              , "plus"
              ) ;
}